var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0088 19.707C11.8616 19.707 11.7422 19.5875 11.7422 19.4403V16.7203C11.7422 16.6307 11.6398 16.5816 11.5694 16.6371L4.48883 22.1731C4.38003 22.2584 4.38003 22.4227 4.48883 22.508L11.5694 28.076C11.6398 28.1315 11.7422 28.0803 11.7422 27.9928V25.307C11.7422 25.1598 11.8616 25.0403 12.0088 25.0403L20.9006 25.051C22.7139 25.051 24.4526 24.3299 25.7368 23.0478C27.019 21.7656 27.74 20.027 27.74 18.2115V16.1742C27.74 16.0803 27.6099 16.0526 27.5736 16.14C27.1448 17.179 25.8819 19.7091 23.7464 19.7091H12.0088V19.707Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0017 13.3433C20.1489 13.3433 20.2684 13.4628 20.2684 13.61V16.33C20.2684 16.4196 20.3708 16.4686 20.4412 16.4132L27.5217 10.8772C27.6305 10.7918 27.6305 10.6276 27.5217 10.5422L20.4412 4.97423C20.3708 4.91877 20.2684 4.96997 20.2684 5.05744V7.7433C20.2684 7.8905 20.1489 8.00997 20.0017 8.00997L11.11 7.9993C9.29664 7.9993 7.55797 8.72037 6.27371 10.0025C4.99157 11.2846 4.27051 13.0233 4.27051 14.8388V16.8761C4.27051 16.97 4.40064 16.9977 4.43691 16.9102C4.86571 15.8713 6.12864 13.3412 8.26411 13.3412H20.0017V13.3433Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.1a929b1c.svg";
export { ForwardRef as ReactComponent };